/**
 * Statuses that mean "the server could not answer, trying again may work" and
 * therefore get the generic localized server-error message rather than the
 * body the API sent.
 *
 * 503 and 408 come from the render endpoints: the API answers 503 (with
 * Retry-After) while its renderer circuit breaker is open, and 408 when a
 * render times out.
 */
export const SERVER_ERROR_CODES = [408, 500, 502, 503];
